import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ServerConn } from '../serverConn.service';

@Injectable()
export class LibrosService {

    data: any[] = [];
    length = 0;
    summary: any[] = [];
    imported = 0;
    animal: any[] = [];
    @Output()
    needUpdate: EventEmitter<any> = new EventEmitter();
    selectedCEA = '';

    constructor(
        private server: ServerConn
    ) { }

    setCEA(cea) {
        this.selectedCEA = cea;
        this.needUpdate.emit(cea);
    }

    get(): Observable<any> {
        if (!this.data.length) {
            /**
             * Retornamos todos los animales de la db
             */
            return Observable.create(observer => {
                this.server.get(
                    'reports/libros',
                    {
                        a: 'g'
                    }
                ).subscribe(
                    (res: any) => {
                        const resp = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = resp.data;
                        this.length = resp.length;
                        console.log(resp);
                        observer.next(res);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        } else {
            return of(this.data);
        }
    }

    getCEA(cea): Observable<any> {
        // if (!this.data.length) {
            /**
             * Retornamos todos los animales de la db
             */
            return Observable.create(observer => {
                this.server.get(
                    'reports/libros',
                    {
                        a: 'g',
                        tblfilter: JSON.stringify([
                            {
                                value: cea,
                                operation: '=',
                                field: 'cea'
                            }
                        ])
                    }
                ).subscribe(
                    (res: any) => {
                        const resp = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = resp.data;
                        this.length = resp.length;
                        console.log(resp);
                        observer.next(res)
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        // } else {
        //     return Observable.of(this.data);
        // }
    }

    getAnimals(
        filter: any,
        sort: string,
        book: number,
        init: string,
        end: string,
        start: number,
        limit: number,
        snapshot = '',
        version = '3',
        year: any = ''): Observable<any> {
        // if (!this.data.length) {
            /**
             * Retornamos los animales paginados, ordenados y filtrados desde el servidor
             */
            console.log(filter, JSON.stringify(filter), sort, start, limit);
            if (this.server.user.level >= 7 && this.selectedCEA > '') {
                filter.cea = {
                    field: 'cea',
                    operation: '=',
                    value: this.selectedCEA
                };
            }
            return Observable.create(observer => {
                this.server.get(
                    'reports/libros',
                    {
                        a: 'g',
                        book: (book > -1) ? book : '',
                        init: init,
                        end: end,
                        tblfilter: JSON.stringify(filter),
                        tblorder: sort,
                        tblstart: start,
                        tbllimit: limit,
                        initSnapshot: snapshot,
                        version: version,
                        year: year
                    }
                ).subscribe(
                    (res: any) => {
                        const resp = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = resp.data;
                        this.length = resp.length;
                        this.summary = resp.summary;
                        this.imported = resp.imported;
                        observer.next(res);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        // } else {
        //     return Observable.of(this.data);
        // }
    }

    getCSV(
        filter: any,
        sort: string,
        book: number,
        init: string,
        end: string,
        snapshot = ''): Observable<any> {
        // if (!this.data.length) {
            /**
             * Retornamos los animales paginados, ordenados y filtrados desde el servidor
             */
            console.log(filter, JSON.stringify(filter), sort);
            if (this.server.user.level >= 7 && this.selectedCEA > '') {
                filter.cea = {
                    field: 'cea',
                    operation: '=',
                    value: this.selectedCEA
                };
            }
            return Observable.create(observer => {
                this.server.download(
                    'reports/libros',
                    {
                        a: 'gcsv',
                        book: (book > -1) ? book : '',
                        init: init,
                        end: end,
                        tblfilter: JSON.stringify(filter),
                        tblorder: sort,
                        initSnapshot: snapshot
                    }
                ).subscribe(
                    (res: any) => {
                        console.log(res);
                        const keys = res.headers.keys();
                        const headers = keys.map(key =>
                            `${key}: ${res.headers.get(key)}`);
                        console.log(headers);

                        const blob = new Blob([res.body], { type: 'text/csv' });
                        const filename = res.headers.get('File-Name');
                        const element = document.createElement('a');
                        element.href = window.URL.createObjectURL(blob);
                        element.download = filename;
                        document.body.appendChild(element);
                        element.click();
                        // window.open(url);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        // } else {
        //     return Observable.of(this.data);
        // }
    }

    getAnimal(bolo: string): any {
        return Observable.create(observer => {
            this.server.get(
                'animals/' + bolo
            ).subscribe(
                (res: any) => {
                    this.animal = (typeof res.json !== 'undefined') ? res.json() : res;
                    observer.next(res)
                }, // simply passing success response
                err => { //error handling
                       observer.error(err); // passing error to the method which invoked request
                },
                () => observer.complete // passing onComplete event);
            );
        });
    }

}
